export const aboutTranslations = {
  en: {
    hero: {
      home: 'Home',
      aboutUs: 'About Us',
      heading: 'About Champion Maker',
      subheading: 'A new perspective on your training',
      tagline: 'Empowering Athletes Across Bulgaria',
    },
    whoWeAre: {
      heading: 'Who We Are',
      text1: "Champion Maker is a Bulgaria-based company that specializes in organizing world-class sports training camps throughout the country. We provide comprehensive training solutions for athletes of all levels, from youth development programs to elite professional camps.",
      text2: "With state-of-the-art facilities across Bulgaria's most prestigious sports venues, we offer a complete training camp experience that includes facility booking, accommodation, meals, transportation, and equipment. Our expert team ensures every detail is handled so athletes and coaches can focus entirely on performance and development.",
      ourLocations: 'Our Locations',
    },
    mission: {
      heading: 'Our Mission',
      text1: 'To empower athletes to reach peak performance by providing a world-class training environment, expert support, and a seamless camp experience within a friendly, inclusive, and empowering atmosphere.',
      text2: 'We welcome athletes from all sports, both team and individual disciplines—as well as Paralympic athletes—creating a supportive community where athletes feel valued, motivated, and confident to grow and perform at their best.',
    },
    features: {
      heading: 'Why Choose Champion Maker',
      subheading: 'What Sets Us Apart',
      items: [
        { title: 'World-Class Facilities', description: "Access to Bulgaria's premier sports venues including Olympic-standard pools, professional courts, and state-of-the-art training centers." },
        { title: 'Expert Support', description: 'Professional staff and experienced coordinators who understand the unique needs of training camps and athlete development.' },
        { title: 'Complete Packages', description: 'All-inclusive solutions covering accommodation, meals, transportation, equipment rental, and facility bookings.' },
        { title: 'Inclusive & Welcoming', description: 'We welcome athletes from all sports and abilities, including Paralympic athletes, fostering a supportive and empowering community.' },
        { title: 'Premium Locations', description: 'Strategic locations across Bulgaria in Sofia, Plovdiv, and Kranevo, offering diverse training environments.' },
        { title: 'Seamless Experience', description: 'From planning to execution, we handle every detail so you can focus on what matters—training and performance.' },
      ],
    },
    vision: {
      heading: 'Our Vision',
      text1: 'To be a trusted global partner in athlete development—recognized for excellence in performance environments, inclusive practices, and long-term athlete pathways.',
      text2: 'We envision a future where athletes of all abilities have access to world-class training systems, personalized support, and positive sporting experiences that foster peak performance, resilience, and sustainable success at every level of sport.',
    },
    sports: {
      heading: 'Sports We Serve',
      subheading: 'Training Camps for Every Discipline',
      items: ['Basketball', 'Volleyball', 'Football', 'Swimming', 'Water Polo', 'Artistic Swimming', 'Athletics', 'Track & Field', 'Team Sports', 'Individual Sports', 'Paralympic Sports', 'And More...'],
    },
    commitment: {
      heading: 'Our Commitment to Excellence',
      text: "At Champion Maker, we are committed to creating an environment where every athlete can thrive. Whether you're preparing for competition, building team chemistry, or developing individual skills, we provide the resources, support, and atmosphere needed for success.",
      stats: ['Training Camps Organized', 'Sports Disciplines', 'Premium Locations', 'Athletes Served'],
    },
    cta: {
      heading: 'Ready to Plan Your Training Camp?',
      subheading: 'Let us help you create an unforgettable training experience',
      explorePackages: 'Explore Our Packages',
      contactUs: 'Contact Us',
    },
  },
  ar: {
    hero: {
      home: 'الرئيسية',
      aboutUs: 'من نحن',
      heading: 'عن صناع الأبطال',
      subheading: 'منظور جديد على تدريبك',
      tagline: 'تمكين الرياضيين في جميع أنحاء بلغاريا',
    },
    whoWeAre: {
      heading: 'من نحن',
      text1: 'صناع الأبطال شركة مقرها بلغاريا تتخصص في تنظيم معسكرات تدريب رياضية عالمية المستوى في جميع أنحاء البلاد. نقدم حلول تدريب شاملة لرياضيين بمستويات مختلفة، من برامج تنمية الشباب إلى معسكرات النخبة الاحترافية.',
      text2: 'مع مرافق حديثة في أعرق الملاعب الرياضية في بلغاريا، نقدم تجربة معسكر تدريب كاملة تشمل حجز المرافق والإقامة والوجبات والنقل والمعدات. يضمن فريقنا الخبير معالجة كل التفاصيل حتى يتمكن الرياضيون والمدربون من التركيز بالكامل على الأداء والتطوير.',
      ourLocations: 'مواقعنا',
    },
    mission: {
      heading: 'مهمتنا',
      text1: 'تمكين الرياضيين من الوصول إلى ذروة الأداء من خلال توفير بيئة تدريب عالمية المستوى ودعم خبراء وتجربة معسكر سلسة ضمن أجواء ودودة وشاملة وتمكينية.',
      text2: 'نرحب بالرياضيين من جميع الرياضات، فرقًا وأفرادًا، وكذلك الرياضيين البارالمبيين، وخلق مجتمع داعم يشعر فيه الرياضيون بالتقدير والحافز والثقة للنمو والأداء بأفضل ما لديهم.',
    },
    features: {
      heading: 'لماذا تختار صناع الأبطال',
      subheading: 'ما يميزنا',
      items: [
        { title: 'مرافق عالمية المستوى', description: 'الوصول إلى أعرق الملاعب الرياضية في بلغاريا بما في ذلك مسابح بأبعاد أولمبية وملاعب احترافية ومراكز تدريب حديثة.' },
        { title: 'دعم خبراء', description: 'طاقم احترافي ومنسقون ذوو خبرة يفهمون الاحتياجات الخاصة لمعسكرات التدريب وتنمية الرياضيين.' },
        { title: 'باقات كاملة', description: 'حلول شاملة تغطي الإقامة والوجبات والنقل وتأجير المعدات وحجز المرافق.' },
        { title: 'شامل ومرحب', description: 'نرحب بالرياضيين من جميع الرياضات والقدرات، بما في ذلك الرياضيون البارالمبيون، وننمي مجتمعًا داعمًا وتمكينيًا.' },
        { title: 'مواقع متميزة', description: 'مواقع استراتيجية في جميع أنحاء بلغاريا في صوفيا وبلوفديف وكرانييفو، تقدم بيئات تدريب متنوعة.' },
        { title: 'تجربة سلسة', description: 'من التخطيط إلى التنفيذ، نتعامل مع كل التفاصيل حتى تتمكن من التركيز على ما يهم — التدريب والأداء.' },
      ],
    },
    vision: {
      heading: 'رؤيتنا',
      text1: 'أن نكون شريكًا عالميًا موثوقًا في تنمية الرياضيين — معروفين بالتميز في بيئات الأداء والممارسات الشاملة ومسارات الرياضيين على المدى الطويل.',
      text2: 'نتصور مستقبلًا يتمكن فيه الرياضيون من جميع القدرات من الوصول إلى أنظمة تدريب عالمية المستوى ودعم مخصص وتجارب رياضية إيجابية تعزز ذروة الأداء والمرونة والنجاح المستدام على كل مستوى من مستويات الرياضة.',
    },
    sports: {
      heading: 'الرياضات التي نخدمها',
      subheading: 'معسكرات تدريب لكل تخصص',
      items: ['كرة السلة', 'الكرة الطائرة', 'كرة القدم', 'السباحة', 'كرة الماء', 'السباحة الإيقاعية', 'ألعاب القوى', 'الجري والميدان', 'الرياضات الجماعية', 'الرياضات الفردية', 'الرياضات البارالمبية', 'والكثير...'],
    },
    commitment: {
      heading: 'التزامنا بالتميز',
      text: 'في صناع الأبطال، نلتزم بخلق بيئة يمكن لكل رياضي أن يزدهر فيها. سواء كنت تستعد للمنافسة أو تبني كيمياء الفريق أو تطور المهارات الفردية، نقدم الموارد والدعم والأجواء اللازمة للنجاح.',
      stats: ['معسكرات تدريب منظمة', 'تخصصات رياضية', 'مواقع متميزة', 'رياضيون تم خدمتهم'],
    },
    cta: {
      heading: 'مستعد لتخطيط معسكر تدريبك؟',
      subheading: 'دعنا نساعدك في خلق تجربة تدريب لا تُنسى',
      explorePackages: 'استكشف باقاتنا',
      contactUs: 'اتصل بنا',
    },
  },
};
